import HTTPClient, { httpErrorParser } from 'lib/helpers/HTTPClient'
import { setUserData, setUserRole } from 'actions/user'

import { Profile } from 'models/user'
import { ROLES } from '../constants'

const api = process.env.REACT_APP_APIURL || '/api'

export const getProfile =
  (noSave: boolean = false) =>
  async (dispatch: any) => {
    const client = HTTPClient.getClient()
    try {
      const petition = await client.get(`${api}/profile`)
      const profile: Profile = await petition.json()
      !noSave && dispatch(setUserData(profile))
      return profile
    } catch (err: any) {
      const error = await httpErrorParser(err)
      throw error
    }
  }

export const getRole =
  (noSave: boolean = false) =>
  async (dispatch: any) => {
    const client = HTTPClient.getClient()
    try {
      const petition = await client.get(`${api}/users/roles`)
      const data = await petition.json()
      const roleId = data[0]?.idRole ?? 4
      const role = Object.values(ROLES).find(r => r.id === roleId)

      !noSave && role && dispatch(setUserRole(role))
      return role
    } catch (err: any) {
      const error = await httpErrorParser(err)
      throw error
    }
  }
